import { render, staticRenderFns } from "./MoveToTrashButton.vue?vue&type=template&id=74f14702&"
import script from "./MoveToTrashButton.vue?vue&type=script&lang=js&"
export * from "./MoveToTrashButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports